import React, { useState, lazy } from 'react';
import { RadarIcon } from 'lucide-react';
type CompanyLogoProps = {
  website: string;
  name: string;
  size?: 'sm' | 'md' | 'lg';
};
export function CompanyLogo({
  website,
  name,
  size = 'md'
}: CompanyLogoProps) {
  const [hasError, setHasError] = useState(false);
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };
  const iconSizes = {
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };
  const domain = website.replace(/^https?:\/\//, '').replace(/\/$/, '');
  const logoUrl = `https://logo.clearbit.com/${domain}`;
  if (hasError) {
    return <div className={`${sizeClasses[size]} rounded-xl bg-amber-500/10 flex items-center justify-center shrink-0`} data-id="element-172">
        <RadarIcon className={`${iconSizes[size]} text-amber-500`} data-id="element-173" />
      </div>;
  }
  return <img src={logoUrl} alt={`${name} logo`} className={`${sizeClasses[size]} rounded-xl object-contain bg-white p-1.5 shrink-0`} onError={() => setHasError(true)} loading="lazy" data-id="element-174" />;
}